import { APIProvider, useMapsLibrary } from '@vis.gl/react-google-maps';
import { useEffect, useState } from 'react';

import { useLocale } from 'src/i18n/IntlProviderWrapper';
const GOOGLE_MAPS_TOKEN = import.meta.env.VITE_GOOGLE_MAPS_TOKEN;

export const WithGoogleApi = ({
  children,
}: Readonly<{
  children: React.ReactNode;
}>) => {
  const { language } = useLocale();
  return (
    <APIProvider apiKey={GOOGLE_MAPS_TOKEN} language={language}>
      {children}
    </APIProvider>
  );
};

export function usePlacesService(map: HTMLDivElement | null) {
  const placesLibrary = useMapsLibrary('places');
  const [placesService, setPlacesService] = useState<google.maps.places.PlacesService | null>(null);

  useEffect(() => {
    if (!placesLibrary || !map) return;
    setPlacesService(new placesLibrary.PlacesService(map));
  }, [placesLibrary, map]);

  return placesService;
}

/**
 * @deprecated As of March 1st, 2025, google.maps.places.AutocompleteService is not available to new customers.
 * Please use AutocompleteSuggestion instead. At this time, google.maps.places.AutocompleteService is not scheduled
 * to be discontinued, but AutocompleteSuggestion is recommended over google.maps.places.AutocompleteService. While
 * google.maps.places.AutocompleteService will continue to receive bug fixes for any major regressions, existing bugs
 * in google.maps.places.AutocompleteService will not be addressed. At least 12 months notice will be given before
 * support is discontinued. Please see https://developers.google.com/maps/legacy for additional details and
 * https://developers.google.com/maps/documentation/javascript/places-migration-overview for the migration guide.
 */
export function useAutocompleteService() {
  const placesLibrary = useMapsLibrary('places');
  const [autocompleteService, setAutocompleteService] = useState<google.maps.places.AutocompleteService | null>(null);

  useEffect(() => {
    if (!placesLibrary) return;
    setAutocompleteService(new placesLibrary.AutocompleteService());
  }, [placesLibrary]);

  return autocompleteService;
}
export function usePlaces() {
  const placesLibrary = useMapsLibrary('places');
  return placesLibrary;
}
